import React, { memo, useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';

import * as _ from 'lodash';
import { numberFormat } from 'utils';
import { log } from 'utils';

function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function ChartMarketNNBuy(props) {
  const DEFAULT_OPTION = {
    grid: { top: 10, right: 15, bottom: 50, left: 40 },
    title: {
      show: false,
      text: 'Log Axis',
      left: 'center',
    },
    tooltip: {
      show: true,
      trigger: 'item',
      // formatter: '{a} <br/>{b}: {c}',
      formatter: function (value, index) {
        // console.log(value);
        // triệu
        if (props.afterFix === 'triệu') {
          if (value.value > 100000)
            return `${value.name} : ${numberFormat(
              Math.abs(value.value) / 1000
            )} tỷ`;
          if (value.value > 1000)
            return `${value.name} : ${numberFormat(
              Math.abs(value.value) / 1000,
              2
            )} tỷ`;
          return `${value.name} : ${numberFormat(Math.abs(value.value))} triệu`;
        }

        return `${value.name} : ${numberFormat(Math.abs(value.value))} ${
          props.afterFix || ''
        }`;
      },
    },
    legend: {
      show: false,
    },
    series: {
      name: 'KL giao dịch',
      type: 'treemap',
      with: '100%',
      height: '100%',
      left: '0',
      top: '0',
      right: '0',
      bottom: '0',
      squareRatio: 1,
      nodeClick: false,
      roam: false,
      label: {
        show: true,
        // formatter: '{b}({@score})',
        formatter: '{b}',
        fontSize: 12,
        color: '#27272D',
      },
      itemStyle: {
        borderColor: '#2E2D3D',
        gapWidth: 1,
      },
      breadcrumb: {
        show: false,
      },
      data: [
        {
          value: 100,
          name: ' ',
          children: [],
        },
      ],
    },
  };

  const [option, setOption] = useState(DEFAULT_OPTION);

  const { tangGiam, typeOrder } = props;

  const preTangGiam = usePrevious(tangGiam);
  const preTypeOrder = usePrevious(typeOrder);
  let timer;

  useEffect(() => {
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (
      tangGiam &&
      (!_.isEqual(tangGiam, preTangGiam) || !_.isEqual(typeOrder, preTypeOrder))
    ) {
      _mapDataToState(tangGiam);
    }
  }, [tangGiam, typeOrder]);

  function _mapDataToState(res) {
    const newOption = _.cloneDeep(option);

    let objData = [];

    for (let index = 0; index < res.name.length; index++) {
      objData.push({
        name: res.name[index],
        value: typeOrder === 'M' ? res.value[index] : res.ptvalue[index],
        itemStyle: {
          color: res.color[index],
        },
      });
    }

    // newOption.xAxis.data = _data;
    newOption.series.data[0].children = objData;

    // // log(newOption);

    setOption(newOption);
  }

  function onChartReady(echarts) {
    // console.log(echarts)
    timer = setTimeout(function () {
      echarts.hideLoading();
    }, 1000);
  }

  return (
    <ReactECharts
      option={option}
      // showLoading
      // onChartReady={onChartReady}
      style={{
        height: '100%',
        width: `100%`,
      }}
    />
  );
}

export default memo(ChartMarketNNBuy);
